import styled, { css, keyframes } from 'styled-components';

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const motionSafe = (styles: ReturnType<typeof css>) => css`
    @media (prefers-reduced-motion: no-preference) {
        ${styles}
    }
`;

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    max-width: 400px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    ${motionSafe(css`
        animation: ${fadeSlideUp} 0.35s ease-out;
    `)}
`;

export const Section = styled.div<{ $index?: number }>`
    width: 100%;

    ${({ $index }) =>
        typeof $index === 'number' &&
        motionSafe(css`
            /* "backwards" (not "both") on purpose: "both" would leave a
               non-none transform on this element permanently after the
               animation ends, which creates a new containing block for any
               position:fixed descendant (e.g. a details modal), pinning it
               near the top of this section instead of centering in the
               real viewport. */
            animation: ${fadeSlideUp} 0.35s ease-out backwards;
            animation-delay: ${Math.min($index, 4) * 0.06}s;
        `)}
`;

export const EnterMoreDetails = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    padding: 24px 0 16px 0;
    border-bottom: 1px solid #c9c8d2;
`;

export const Details = styled.div`
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #040222;
    margin: 24px auto;
`;

export const StaticWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 12px;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
`;

export const InputLabel = styled.p`
    margin-bottom: 10px;
    font-size: 1rem;
    font-weight: 500;
`;

export const ItemWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px 0;
`;

export const MandatoryStar = styled.span`
    margin-bottom: 4px;
    color: red;
    margin-left: 4px;
`;

export const DocumentUploadErrorMessage = styled.div`
    display: flex;
    font-size: 12px;
    line-height: 16px;
    margin-top: 4px;
    color: #d83d37;
`;
